jQuery(document).ready(function() {
    $('body').click(function() {
        $('.header-menu__inner, .header-menu').removeClass('active');
        $('.menu-sidebar li, .content-section').removeClass('active');
        $('.mega-menu-wrapper').slideUp(200);
    });

    $('.menu-trigger').click(function(e) {
        e.stopPropagation();
        $('.header-menu__inner, .header-menu').toggleClass('active');
        $('.mega-menu-wrapper').slideToggle(200);
        if (!$('.header-menu__inner').hasClass('active')) {
            $('.menu-sidebar li, .content-section').removeClass('active');
        }
    })

    $('.mega-menu-wrapper').click(function(e) {
        e.stopPropagation();
    });

    // Xử lý khi hover vào các mục ở sidebar
    $('.menu-sidebar li').on('mouseenter', function() {
        // Lấy ID của section mục tiêu
        var target = $(this).data('target');
        $('.menu-content').removeClass('active');
        // Xóa active ở sidebar
        $('.menu-sidebar li').removeClass('active');
        // Nếu không có target (các mục chưa làm nội dung), thoát hàm
        if($('#' + target).length == 0) return;

        $(this).addClass('active');
        $('.menu-content').addClass('active');
        // Ẩn tất cả các section bên phải và hiện section tương ứng
        $('.content-section').removeClass('active');
        $('#' + target).addClass('active');
    });

    $(".footer-middle .row > [class^='col-'] .column-name").click(function() {
        if ($(window).width() <= 991) {
            $(this).toggleClass("active").next().toggle();
        }
    });


    $(".toggle-menu-mb").click(function() {
      $(this).toggleClass("active");
      $(".mobile-menu-drawer").toggleClass("active");
    });
    $(".mb-close-btn").click(function() {
        $(".mobile-menu-drawer, .toggle-menu-mb").removeClass("active");
    });
    // 1. Xử lý khi nhấn vào nút mở cấp tiếp theo
  $('.next-layer-btn').on('click', function(e) {
    e.preventDefault();
    
    const targetId = $(this).data('target');
    const $nextLayer = $('#' + targetId);
    const $currentLayer = $(this).closest('.menu-layer');

    // Layer hiện tại: trượt sang trái (sub-active)
    $currentLayer.removeClass('active').addClass('sub-active');
    
    // Layer mục tiêu: trượt vào từ bên phải (active)
    $nextLayer.addClass('active');
    
    // Cuộn lên đầu menu khi chuyển cấp
    $('.mobile-menu-drawer').animate({ scrollTop: 0 }, 300);
  });

  // 2. Xử lý khi nhấn vào nút "Zurück" (Quay lại)
  $('.back-layer-btn').on('click', function(e) {
    e.preventDefault();
    
    const $currentLayer = $(this).closest('.menu-layer');
    
    // Tìm layer cha gần nhất đang ở trạng thái 'sub-active'
    // Chúng ta tìm layer sub-active cuối cùng trong cây DOM trước layer hiện tại
    const $parentLayer = $('.menu-layer.sub-active').last();

    // Layer hiện tại: trượt ra bên phải
    $currentLayer.removeClass('active');
    
    // Layer cha: quay lại trạng thái hiển thị (active)
    if ($parentLayer.length) {
      $parentLayer.removeClass('sub-active').addClass('active');
    }
  });

  // 3. Đóng Menu (Tùy chọn)
  $('.close-drawer').on('click', function() {
    $('.mobile-menu-drawer').removeClass('open'); // Giả sử bạn có class 'open' để hiện drawer
    // Reset toàn bộ menu về cấp 0 khi đóng
    setTimeout(function() {
      $('.menu-layer').removeClass('active sub-active');
      $('#layer-main').addClass('active');
    }, 400);
  });
});